import { render, staticRenderFns } from "./ApplyLeave.vue?vue&type=template&id=60547e3a&scoped=true&"
import script from "./ApplyLeave.vue?vue&type=script&lang=js&"
export * from "./ApplyLeave.vue?vue&type=script&lang=js&"
import style0 from "./ApplyLeave.vue?vue&type=style&index=0&id=60547e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60547e3a",
  null
  
)

export default component.exports